<template>
  <div>
    <div class="form-list">
      <div class="form-header">일반</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="X / Y">
          <el-input-number v-model="formModel.x" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.y" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="가로 / 세로">
          <el-input-number v-model="formModel.width" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.height" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="회전">
          <el-input-number v-model="formModel.r" :precision="0" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">대상</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="레이블" v-show="!isWidget">
          <el-input v-model="formModel.label" :style="labelField"></el-input>
          <el-dropdown :hide-on-click="false" placement="bottom" @command="onCommandClick">
            <el-tooltip content="구분자 선택 시 레이블에 반영됩니다." placement="top" :open-delay="MapConst.TOOLTIP_DELAY">
              <i class="el-icon-info"></i>
            </el-tooltip>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="%node%" :style="labelCommand">노드명</el-dropdown-item>
              <el-dropdown-item command="%n%" :style="labelCommand">[ENTER]</el-dropdown-item>
              <el-dropdown-item command="%ip%" :style="labelCommand">IP</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <el-form-item label="레이블 보기" v-show="!isWidget">
          <el-checkbox v-model="formModel.showLabelFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="레이블 박스 보기" v-show="!isWidget">
          <el-checkbox v-model="formModel.showLabelBoxFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="레이블 색" v-show="!isWidget">
          <w-color-field v-model="formModel.labelColor" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="레이블 박스 색" v-show="!isWidget">
          <w-color-field v-model="formModel.labelBoxColor" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="레이블 크기" v-show="!isWidget">
          <el-input-number v-model="formModel.labelOptions.labelSize" :min="1" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
        <el-form-item label="레이블 위치" v-show="!isWidget">
          <w-label-position-select v-model="formModel.labelPosition"></w-label-position-select>
        </el-form-item>
        <el-form-item label="폰트" v-show="!isWidget">
          <el-select v-model="formModel.labelFont" :style="fullField">
            <el-option v-for="item in MapConst.FONT_FAMILIES" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="폰트 굵기" v-show="!isWidget">
          <el-checkbox v-model="formModel.labelOptions.labelBold"></el-checkbox>
        </el-form-item>
        <el-form-item label="이미지 타입">
          <el-radio-group v-model="formModel.styleOptions.imageType">
            <el-radio v-for="(item, index) in MapConst.IMAGE_TYPES" :label="item.value" :key="index" @change="onImageTypeChange(item.value)">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="이미지">
          <w-image-select v-model="formModel.customimageId"></w-image-select>
        </el-form-item>
        <el-form-item label="이벤트 메시지 표현">
          <el-checkbox v-model="formModel.showEventLabelFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="정상 색 표현" v-show="!isWidget">
          <el-checkbox v-model="formModel.styleOptions.showNormalColor"></el-checkbox>
        </el-form-item>
        <el-form-item label="성능 표현">
          <el-checkbox v-model="formModel.showRscFlag" true-label="1" false-label="0"></el-checkbox>
        </el-form-item>
        <el-form-item label="중요도 표현">
          <el-checkbox v-model="formModel.styleOptions.showImportance"></el-checkbox>
        </el-form-item>
        <el-form-item label="인터페이스 이벤트" v-show="isNetDevice">
          <el-checkbox v-model="formModel.showIfEvent" true-label="1" false-label="0" :class="$style['show-if-event']"></el-checkbox>
          <el-tooltip placement="top" :open-delay="MapConst.TOOLTIP_DELAY">
            <div slot="content">체크 : 인터페이스를 포함한 이벤트 상태를 표현합니다.<br/>체크해제 : 네트워크 장비의 이벤트 상태만 표현합니다.</div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import FormMixins from '@/mixins/form';
import WColorField from '@/components/form/ColorField';

import ObjectProperty from '@/mixins/topologymap/object-property';

import WImageSelect from '@/views/topologymap/components/property/ImageSelect';
import WLabelPositionSelect from '@/views/topologymap/components/property/LabelPositionSelect';

export default {
  name: 'WManagedObject',
  components: {
    WColorField,
    WImageSelect,
    WLabelPositionSelect,
  },
  mixins: [ObjectProperty],
  data() {
    return {
    };
  },
  computed: {
    isNetDevice() {
      return this.objects.every((object) => object.get('objDefineId') === 'NETDEVICE');
    },
    isWidget() {
      return this.formModel.styleOptions.imageType === 'widget';
    },
  },
  methods: {
    onImageTypeChange(value) {
      if (this.formModel.customimageId < 1) {
        if (value === 'widget') {
          this.formModel.width = 200;
          this.formModel.height = this.formModel.showRscFlag === '1' ? 94 : 52;
        } else {
          this.formModel.width = 46;
          this.formModel.height = 46;
        }
      }
    },
  },
};
</script>
<style module>
.show-if-event {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/ManagedObjectProperty.vue